export const defaultLocaleLang = 'en';

export const defaultTimezone = 'Europe/Sofia';
